<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="8">
        <v-btn
          color="primary"
          :disabled="startDate == null"
          @click="downloadPrizeQualificationReport"
          :loading="reconLoading"
        >
          Email prize candicate report
        </v-btn>
        <h5 class="mt-3">
          Please make sure you select a monday
        </h5>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { PRIZE_QUALIFICATION_REPORT_QUERY } from "@/constants/graphql/billing/billing";

export default {
  name: "PrizeQualificatio",
  props: {
    startDate: {
      type: String,
    },
  },
  data() {
    return {
      reconLoading: false,
    };
  },
  methods: {
    downloadPrizeQualificationReport() {
      this.reconLoading = true;
      this.$apollo
        .query({
          query: PRIZE_QUALIFICATION_REPORT_QUERY,
          variables: {
            startDate: this.startDate,
          },
        })
        .then((data) => {
          if (data && data.loading === false) {
            this.reconLoading = false;
            this.$toasted.success("A email will be sent your email this may take up to 10 minutes", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
  },
};
</script>
